import { render } from "./ProgramsPage.vue?vue&type=template&id=70fe4f6a&scoped=true"
import script from "./ProgramsPage.vue?vue&type=script&lang=js"
export * from "./ProgramsPage.vue?vue&type=script&lang=js"

import "./ProgramsPage.vue?vue&type=style&index=0&id=70fe4f6a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fe4f6a"]])

export default __exports__